import { useCallback } from "react";
import { useSelector } from "react-redux";

/**
 * Prevents scroll on pressing the up and down arrow keys if both workspace item or the subtitle is selected.
 */
const usePreventScrollOnArrowKeys = () => {
    const { selectedItemsSize, selectedSubtitlesSize } = useSelector((state) => ({
        selectedItemsSize: state.app.get("selectedItems").size,
        selectedSubtitlesSize: state.app.get("selectedSubtitles").size,
    }));

    return useCallback((e) => {
        if ((e.key === "ArrowUp" || e.key === "ArrowDown") &&
            (selectedItemsSize > 0 || selectedSubtitlesSize > 0)) {
            e.preventDefault();
        }
    }, [selectedItemsSize, selectedSubtitlesSize]);
};

export default usePreventScrollOnArrowKeys;